import "./about.css";
import { aboutTitle, aboutDescription } from "./text";
import Reveal from "../../utils/Reveal";
import aircraft from "../../../assets/images/aircraft4.png";

const About = () => {
  return (
    <div className="container about-section pb-5">
      <div className="row align-items-center justify-content-center">
        <div className="col-lg-5 mb-4 mb-lg-0 about-description">
          <Reveal animationType="fadeInRight">
            <h2 className="mb-4" style={{ color: "rgba(0, 74, 173, 0.85)" }}>
              {aboutTitle}
            </h2>
            <p className="fs-17">{aboutDescription}</p>
          </Reveal>
        </div>
        <div className="col-lg-7 text-center img-wrapper">
          <img
            src={aircraft}
            alt="Aircraft"
            className="rounded img-fluid about-image"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
